import BaseObject from '../../../../base/base_object';
import Model from './info_hybrid_model';
import {INFO, INFO_ALL} from './info_hybrid_consts';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import _ from '../../../../utils/underscore';
import Device from "../../../../utils/device/device";

class HybridInfo extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HybridInfo';

    _model = null;
    _HybridService = null;

    init(params) {
        super.init();

        this._model = Model.create(params);

        this._subscribe();
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, this._initInfo, this);
        Event.on(SYSTEM_EVENTS.HYBRID_UPDATE_INFO_KEY, this._updateKey, this);
    }

    _initInfo() {
        this.getAllInfo();
    }

    _updateKey(data){

        if(data) {
            this._model._addKeys(data.key, data.val);
        }
    }

    /**
     * @update the data from hybrid
     * @param data:  example: {type: "HybridInfoFeature", action: "debug", url: "https://mirage-cgp-client.888sport.com", reload: "true"}
     */

    onHybridDirectCall(data) {
        this._model.updateData(data);
        this.setUrl();

        let autologinToken = this._model.getAutologinToken();

        if(autologinToken) {
            this._HybridService.runAutologin({userinfo: autologinToken, sessionTimer: this._model.getSessionTimerOffset()});
        }
    }

    /**
     * @set a new url in hybrid hybrid
     */

    setUrl() {
        let url = this._model.getUrl();
        let reload = this._model.getReload();
        if (undefined !== url && url.length > 0) {
            this._HybridService.setUrl(url, reload);
        }
    }

    /**
     * is debug mode ( for the info display )
     * @returns bool
     */
    isDebugMode() {
        return this._model.isDebugMode();
    }

    /**
     * get all the info from hybrid(version, name, bundleid... ( for the info display )
     */
    getAllInfo() {
        return this._HybridService.getInfo(INFO_ALL).then(data => {
            this._model.updateAllInfo(data);

            if(Device.hybrid.inCasino) {
                let ver =  this.getFullVersion();
                Event.fire(SYSTEM_EVENTS.ADD_TAG_OPEN_APP_VER, ver);
            }
        });
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        return this;
    }

    getFullVersion(){
       return this.getVersion() + '-' + this.getBuild();
    }

    getBuild() {
        return this._model.getVal(INFO.BUILD, 0);
    }

    getAppleID() {
        return this._model.getVal(INFO.AppleID, '');
    }

    getVersion() {
        return this._model.getVal(INFO.VER, 0);
    }

    getUrlScheme() {
        return this._model.getVal(INFO.URL_SCHEME, '');
    }

    getInfo() {
        return this._model.getInfo();
    }

    /**
     * get Info For Display - (used in the menu)
     * @returns info in html format
     */
    getInfoForDisplay() {
        let val, key, html = '';
        let count = 0;
        this._model.getInfo().forEach(item => {

            count++;
            val = item.val;
            key = item.key;

            if ('SerialData' === key) {
                val = JSON.stringify(_.safeJSONandDecode(val));
            }

            html += count + '. ' +  key + ': ' + val + '<br>';
        });

        return '<ol style="background-color: transparent; margin:0px">' + html + '</ol>';
    }
}

export default HybridInfo;
